// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const te: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'ఎలా ఆడాలి',
  'howto.pieces.heading': 'ముక్కలు',
  'howto.pieces.source': 'మూలం',
  'howto.pieces.mirror': 'అద్దం',
  'howto.pieces.switch': 'స్విచ్',
  'howto.pieces.exit': 'నిష్క్రమణ',
  'howto.pieces.wall': 'గోడ',
  'howto.controls.heading': 'నియంత్రణలు',
  'howto.controls.clickSlot.line1': 'స్లాట్‌ను క్లిక్ చేయి',
  'howto.controls.clickSlot.line2': 'అద్దాన్ని ఉంచు',
  'howto.controls.dragMirror.line1': 'అద్దాన్ని లాగు',
  'howto.controls.dragMirror.line2': 'తిప్పు',
  'howto.controls.rightClick.line1': 'రైట్-క్లిక్',
  'howto.controls.rightClick.line2': 'అద్దాన్ని తీసివేయి',
  'howto.controls.hint': 'మౌస్ వీల్: 1° సున్నితంగా తిప్పు.   అద్దాన్ని టాప్: 15° తిప్పు.',
  'howto.objective.line1': 'ప్రతి స్విచ్‌ను వెలిగించు — నిష్క్రమణ తాళం తెరుచుకుంటుంది.',
  'howto.objective.line2': 'తర్వాత నిష్క్రమణపై క్లిక్ చేయి. వీలైనన్ని తక్కువ అద్దాలతో పరిష్కరించు.',

  'howtoColor.title': 'రంగు మరియు ప్రిజమ్‌లు',
  'howtoColor.pieces.heading': 'కొత్త ముక్కలు',
  'howtoColor.pieces.prism': 'ప్రిజమ్',
  'howtoColor.pieces.redSwitch': 'ఎరుపు స్విచ్',
  'howtoColor.pieces.yellowSwitch': 'పసుపు స్విచ్',
  'howtoColor.pieces.whiteSwitch': 'తెలుపు స్విచ్',
  'howtoColor.how.heading': 'అవి ఎలా పనిచేస్తాయి',
  'howtoColor.how.line1': 'తెల్లని కిరణం ఎరుపు, ఆకుపచ్చ, నీలి కాంతిని ఒకేసారి మోసుకెళుతుంది.',
  'howtoColor.how.line2':
    'ప్రిజమ్ తెల్లని కాంతిని తన మూడు భుజాల వెంట మూడు రంగుల కిరణాలుగా విభజిస్తుంది.',
  'howtoColor.how.line3': 'ఉంచిన ప్రిజమ్‌పై క్లిక్ చేసి దాని ఇన్‌పుట్ ముఖాన్ని తిప్పు.',
  'howtoColor.switches.line1': 'స్విచ్‌లు రంగు చుక్కలను చూపుతాయి — అదే వాటికి కావాల్సిన రంగు.',
  'howtoColor.switches.line2':
    'పసుపు స్విచ్‌కు (ఎరుపు + ఆకుపచ్చ చుక్కలు) రెండు రంగులూ కలసి కావాలి.',
  'howtoColor.switches.line3': 'తెల్ల స్విచ్‌కు (మూడు రంగులు) ఎరుపు, ఆకుపచ్చ, నీలి ఒకేసారి కావాలి.',

  'options.hints.label': 'పజిల్స్‌లో సూచన కోణాలను చూపు',
  'options.hints.help':
    'ప్రతి బౌన్స్ వద్ద వచ్చే మరియు ప్రతిబింబించిన కిరణాల మధ్య కోణాన్ని చూపుతుంది.',

  'level.01-intro.title': 'హలో కాంతి',
  'level.02-two-mirrors.title': 'రెండు మలుపులు',
  'level.03-corner.title': 'దారిలో గోడ',
  'level.04-two-targets.title': 'రెండు లక్ష్యాలు',
  'level.05-tight.title': 'ఇరుకు',
  'level.06-hello-color.title': 'హలో రంగు',
  'level.07-pick-a-side.title': 'ఒక వైపును ఎంచుకో',
  'level.08-yellow.title': 'పసుపు',
  'level.09-magenta.title': 'మెజెంటా',
  'level.10-spectrum.title': 'వర్ణపటం',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'లంబ',
  'puzzle.hint.angleType.acute': 'తీవ్ర',
  'puzzle.hint.angleType.obtuse': 'అధిక',
  'puzzle.hint.label': '{angle}°\n{type}',
};
